import React from 'react';
import {Formik, Field, Form} from 'formik';
import {observable} from 'mobx';
import {inject, observer} from 'mobx-react';
import {withRouter, Link, Switch, Route, Router} from "react-router-dom";
import {matchPath, MemoryRouter} from 'react-router';
import classnames from 'classnames';

const validateSignIn = values => {
    let errors = {};
    if (!values.email) {
        errors.email = 'Required';
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
        errors.email = 'Invalid email address';
    }
    if (values.password.length < 10) {
        errors.password = 'Required: The password should consist of at least 10 characters';
    }

    return errors;
};


const validateStartResetPassword = values => {
    let errors = {};
    if (!values.email) {
        errors.email = 'Required';
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
        errors.email = 'Invalid email address';
    }


    return errors;
};


@inject("store")
@observer
class SignIn extends React.Component {
    @observable showForgotPassword = false;
    @observable resetSubmitted = false;
    @observable resetButtonText = "Request password reset";
    @observable resetButtonSubmitted = false;

    constructor(props) {
        super(props);
        this.toggleShowForgotPassword = this.toggleShowForgotPassword.bind(this);
        this.state = {};
    }


    toggleShowForgotPassword() {
        this.showForgotPassword = !this.showForgotPassword;
    }

    render() {

        const navigation = this.props.store.navigation;
        const account = this.props.store.account;

        const match = this.props.match;
        let matchUrl = match.url;
        if (matchUrl.length === 1 && matchUrl[0] === "/") {
            matchUrl = "";
        }
        //console.debug("Match Url Reset password: ", `${matchUrl}/resetpassword`);
        return (
            <div style={{width: "300px"}}>
                <Router history={this.props.store.navigation.mstToolbarHistory} hashType="noslash">
                    <Switch>
                        <Route path="/resetpw">
                            <Formik
                                state={this.state}
                                initialValues={{

                                    email: '',
                                    password: ''
                                }}
                                validate={validateStartResetPassword}
                                onSubmit={(values, actions, resetForm) => {
                                    actions.setStatus({submitting: true, sent: false});
                                    this.resetButtonSubmitted = true;
                                    this.props.store.account.startPasswordReset(values).then(
                                        status => {
                                            console.debug(status);
                                            actions.setSubmitting(false);
                                            actions.setStatus({submitting: false, sent: true});
                                            setTimeout(() => {
                                                actions.resetForm();
                                            }, 5000);
                                        },
                                        error => {
                                            console.debug(error);
                                            actions.setFieldError("custom", error.messages[0]);
                                            actions.setSubmitting(false);

                                            actions.setStatus({submitting: false, sent: false});
                                        }
                                    );
                                }}
                                render={({errors, touched, isSubmitting, isValid, status}) => {

                                    return (
                                        <Form id="reset-form">
                                            <h2>Forgot your password?</h2>
                                            <ol>
                                                <li>Fill in your email address</li>
                                                <li>Click the button below to start resetting your password.</li>
                                                <li>Check your inbox and follow the instructions</li>
                                            </ol>
                                            <div className={classnames("form-group", "input-group", {'has-warning': errors.email && touched.email})}>
                                                <Field className="form-control" name="email" type="email" placeholder="Email..." autoFocus/><span className="input-group-addon"><i className="material-icons mail"></i></span>
                                                {errors.email &&
                                                    touched.email &&
                                                    <div className="form-control-feedback">{errors.email}</div>}
                                            </div>

                                            <button className="btn btn-success btn-block" type="submit" disabled={!isValid || (status && (status.sent || status.submitting))}>

                                                {status && status.sent ? <span>Email sent if an account was found<i key="icon" className="material-icons check"></i></span> : null}
                                                {status && status.submitting ? <span>*Requesting reset...</span> : null}
                                                {!status || (!status.sent && !status.submitting) ? <span>Request password reset</span> : null}
                                            </button>

                                            {errors.custom && <div>{errors.custom}</div>}
                                            <Link to="loginform">Tillbaka till inloggning</Link>
                                        </Form>
                                    );
                                }}
                            />
                        </Route>

                        <Route>
                            <Formik

                                initialValues={{
                                    email: '',
                                    password: ''
                                }}
                                validate={validateSignIn}
                                onSubmit={(values, actions) => {
                                    actions.setStatus({submitting: true, loggedin: false});
                                    this.props.store.account.login(values).then(
                                        status => {
                                            console.debug(status);
                                            actions.setSubmitting(false);
                                            actions.setStatus({submitting: false, loggedin: true});

                                            // If we are on #/login, go to #/
                                            const m = matchPath(navigation.toolbarRouter.location.pathname, "/login");
                                            if (m) {
                                                setTimeout(() => {
                                                        navigation.toolbarRouter.push("/");

                                                    },
                                                    1500);


                                            } else {
                                                setTimeout(() => {
                                                        // todo: implement returnUrl

                                                        location.href = "/";
                                                        //location.reload();
                                                    },
                                                    1500);
                                            }

                                        },
                                        error => {
                                            console.debug(error);
                                            actions.setFieldError("custom", error.messages[0]);
                                            actions.setStatus({submitting: false, loggedin: false});
                                            actions.setSubmitting(false);
                                        }
                                    );

                                }}
                                render={({errors, touched, isSubmitting, isValid, status}) => {
                                    return (
                                        <Form id="login-form">
                                            <h2>Logga in</h2>
                                            <div className={classnames("form-group", "input-group", {'has-warning': errors.email && touched.email})}>
                                                <Field className="form-control" name="email" type="email" placeholder="Email..." autoComplete="username" autoFocus/><span className="input-group-addon"><i className="material-icons mail"></i></span>
                                                {errors.email &&
                                                    touched.email &&
                                                    <div className="form-control-feedback">{errors.email}</div>}
                                            </div>
                                            <div className={classnames("form-group",
                                                "input-group",
                                                {'has-warning': errors.password && touched.password})}>
                                                <Field className="form-control" name="password" type="password" autoComplete="current-password" placeholder="Password"/><span className="input-group-addon"><i
                                                className="material-icons lock"></i></span>
                                                {errors.password &&
                                                    touched.password &&
                                                    <div className="form-control-feedback">{errors.password}</div>}
                                            </div>
                                            <button className="btn btn-success btn-block" type="submit" disabled={!isValid || (status && (status.sent || status.loggedin))}>
                                                {status && !status.submitting && status.loggedin ? <span>Loggar in, omdirigerar&nbsp;<i key="icon" className="material-icons check"></i></span> : null}
                                                {status && status.submitting && !status.loggedin ? <span>*Autentisierar...*</span> : null}
                                                {!status || (!status.sent && !status.loggedin) ? <span>Logga in</span> : null}
                                            </button>

                                            {errors.custom && <div>{errors.custom}</div>}
                                            <br/>
                                            <Link to="resetpw">Har du glömt ditt lösenord ?</Link>
                                        </Form>
                                    );
                                }}
                            />

                        </Route>
                    </Switch>
                </Router>
            </div>
        );
    }
}

export default withRouter(SignIn)